module.exports = __webpack_public_path__ + "img/itau.18e63a6b.svg";